import { memo } from "react"
import { Container, Heading, Box, Image, HStack } from "@chakra-ui/react"
import { useInstagram } from "@app/hooks/useInstagram"
import { InstagramCard } from "./InstagramCard"
import { useSection } from "@app/hooks/useSection"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper"
import { useMedia } from "@app/hooks/useMedia"
import { CustomButton } from "@app/components/Button"

const BACK_ARROW_CLASSNAME = "instagram-carousel-back-arrow"
const NEXT_ARROW_CLASSNAME = "instagram-carousel-next-arrow"

const InstagramArrow = ({ isLeft = false }) => {
  return (
    <Image
      src="/icons/long-arrow.svg"
      className={isLeft ? BACK_ARROW_CLASSNAME : NEXT_ARROW_CLASSNAME}
      cursor="pointer"
      transform={isLeft ? "rotate(180deg)" : {}}
      w={[7, 7, 12]}
    />
  )
}

const Instagram: React.FC<GatsbyTypes.SanitySectionInstagram> = ({ title, analytics, button, bgColor }) => {
  const { items } = useInstagram()
  const { handleTrackingClick } = useSection({ analytics })
  const hasItems = !!items?.length
  const { isMedium } = useMedia()

  return (
    <Box bgColor={bgColor} py={[12, 12, 24]}>
      <Container as="section" textAlign="center">
        <HStack justifyContent="space-between" mb={[6, 6, 16]}>
          <InstagramArrow isLeft />
          {title && (
            <Heading as="p" size="h2">
              {title}
            </Heading>
          )}
          <InstagramArrow />
        </HStack>

        {hasItems && (
          <Swiper
            lazy
            modules={[Navigation]}
            pagination={{ clickable: true }}
            spaceBetween={isMedium ? 16 : 8}
            slidesPerView="auto"
            loop
            navigation={{
              nextEl: `.${NEXT_ARROW_CLASSNAME}`,
              prevEl: `.${BACK_ARROW_CLASSNAME}`,
            }}
          >
            {items?.map((item: any) => (
              <SwiperSlide key={item?.key} className="no-flex">
                <InstagramCard item={item} handleTrackingClick={handleTrackingClick} />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
        {button && <CustomButton linkStyles={{ mt: [11, 11, 16] }} button={button} />}
      </Container>
    </Box>
  )
}

export default memo(Instagram)
